import * as React from 'react';
import type { SVGProps } from 'react';
const SvgVector = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={22}
    fill="currentColor"
    {...props}
  >
    <path d="M0 22h4.318c.36 0 .54 0 .702-.056a1 1 0 0 0 .29-.16c.133-.107.23-.259.421-.563l5.722-9.077c.212-.338.319-.507.355-.69a1 1 0 0 0 .004-.362c-.032-.184-.135-.355-.34-.698L5.726.811c-.19-.316-.285-.475-.42-.585a1 1 0 0 0-.294-.167C4.848 0 4.663 0 4.294 0H0l6.028 10.417c.194.334.29.501.32.68a1 1 0 0 1-.003.352c-.034.178-.135.343-.335.673z" />
  </svg>
);
export default SvgVector;
